<template>
    <SelectionControl
        :aria-label="label"
        :aria-checked="String(value)"
        :aria-disabled="disabled"
        :class="{'isChecked': value, 'isDisabled': disabled}"
        class="appCheckbox"
        role="checkbox"
        tabindex="0"
        @click="clickHandler"
    >
        <div class="icon"></div>
        <div
            v-if="label"
            class="label"
        >
            {{ label }}
        </div>
    </SelectionControl>
</template>

<script>
import SelectionControl from './SelectionControl.vue';

export default {
    components: {
        SelectionControl,
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        label: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        clickHandler() {
            if (this.disabled) return;

            this.$emit('input', !this.value);
        },
    },
};
</script>

<style lang="postcss" scoped>
:root {
    --iconSize: 10px;
}
.icon::after {
    width: calc(var(--iconSize) / 2);
    height: var(--iconSize);
    margin-left: calc(var(--iconSize) / 2 * -1);
    margin-top: 1px;
    transform: scaleX(-1) rotate(135deg);
    transform-origin: top left;
    border-right: 2px solid transparent;
    border-top: 2px solid transparent;
}
.isChecked .icon {
    background-color: var(--primary);
    border-color: var(--primary);
    &::after {
        border-color: #fff;
        animation: check 0.5s;
    }
}
@keyframes check {
    0% {
        width: 0;
        height: 0;
    }
    25% {
        width: calc(var(--iconSize) / 2);
        height: 0;
    }
    50% {
        width: calc(var(--iconSize) / 2);
        height: var(--iconSize);
    }
}
</style>
